
import { defineComponent, computed } from 'vue'

import { useRoute } from 'vue-router'

export default defineComponent({
  props: {
    current: {
      type: String,
      default: 'course'
    },
    tabs: {
      type: Array,
      default: () => ([])
    },
    linkName: {
      type: String,
      default: 'day'
    }
  },
  setup (props) {
    const route = computed(() => useRoute())

    function getLink (tab) {
      return {
        name: props.linkName,
        params: route.value.params,
        query: {
          tab
        }
      }
    }

    return {
      getLink
    }
  }
})
